import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_NOTIFICA } from '../../data.const';
import {
  setCurrentNotificaAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveNotificaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_NOTIFICA),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_NOTIFICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ notificaLoader: true })),
        defer(() =>
          from(
            request({ path: `notifica/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_NOTIFICA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentNotificaAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_NOTIFICA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ notificaLoader: false }))
      );
    })
  );

export default retrieveNotificaEpic;
